import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, type OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { previewPortalAttachAction } from '@web/store/page-structure/widgets/widgets.actions';
import { SpPanelDragHandlerDirective } from '@common/directives/panel-drag-handler.directive';

@Component({
    selector: 'web-settings-body',
    templateUrl: './settings-body.component.html',
    styleUrls: ['./settings-body.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpPanelDragHandlerDirective],
})
export class SettingsBodyComponent implements OnInit {
    private readonly actions$: Actions = inject(Actions);
    private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    public attached: boolean = false;
    ngOnInit(): void {
        this.actions$.pipe(ofType(previewPortalAttachAction.modalPreviewToggle)).subscribe(({ attached }) => {
            this.attached = attached;
            this.changeDetectorRef.detectChanges();
        });
    }
}
